// extracted by mini-css-extract-plugin
export default {"loading":"weather_spinner_loading","spinner":"weather_spinner_x","mini":"weather_spinner_mini","compact":"weather_spinner_compact"};